import { toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';

var focusManager = {
  init: function init() {
    var obj = {};
    return {
      saveFocus: function saveFocus(target, id) {
        obj[id] = target;
        return target;
      },
      restoreFocus: function restoreFocus(id) {
        if (!obj[id]) {
          return null;
        }
        obj[id].focus();
        return obj[id];
      }
    };
  }
};
var conditionalAttribute = function conditionalAttribute(attr, trueValue, falseValue) {
  return function (target) {
    return function (condition) {
      if (target && typeof target.setAttribute === 'function') {
        target.setAttribute(attr, condition ? trueValue || 'true' : falseValue || 'false');
      }
      return target;
    };
  };
};
var setAriaHidden = conditionalAttribute('aria-hidden');
var setDataScrollLock = conditionalAttribute('data-scroll-lock');
var setRootOverlayIndicator = conditionalAttribute('data-root-overlay-indicator');
var setScrollLockOnRoot = function setScrollLockOnRoot(condition) {
  setDataScrollLock(document.documentElement)(condition);
};
var setOverlayIndicatorOnRoot = function setOverlayIndicatorOnRoot(condition) {
  setRootOverlayIndicator(document.documentElement)(condition);
};
var excludedTagnames = ['SCRIPT', 'TEMPLATE', 'STYLE'];
var isNodeTagExcluded = function isNodeTagExcluded(node) {
  return !excludedTagnames.includes(node.tagName);
};
var modalFocusManager = focusManager.init();
var modals = [];
function modalManager() {
  var getTopModal = function getTopModal() {
    var _modals;
    return modals.length ? (_modals = modals[modals.length - 1]) === null || _modals === void 0 ? void 0 : _modals.modal : null;
  };
  var push = function push(modal, container) {
    modals.push({
      modal: modal,
      container: container
    });
    modalFocusManager.saveFocus(document.activeElement, modal === null || modal === void 0 ? void 0 : modal.id);
    _toConsumableArray(container === null || container === void 0 ? void 0 : container.childNodes).filter(isNodeTagExcluded).forEach(function (sibling) {
      var ariaCondition = sibling !== modal && sibling !== modal.closest('.toaster');
      setAriaHidden(sibling)(ariaCondition);
    });
    setScrollLockOnRoot(true);
    setOverlayIndicatorOnRoot(true);
  };
  var pop = function pop() {
    var _modals$pop = modals.pop(),
      modal = _modals$pop.modal,
      container = _modals$pop.container;
    var topModal = getTopModal();
    modalFocusManager.restoreFocus(modal === null || modal === void 0 ? void 0 : modal.id);
    _toConsumableArray(container === null || container === void 0 ? void 0 : container.childNodes).filter(isNodeTagExcluded).forEach(function (sibling) {
      return setAriaHidden(sibling)(topModal ? sibling !== topModal : false);
    });
    var areModalsOpen = modals.length > 0 || document.querySelectorAll('.modal[data-open="true"]').length > 0;
    setScrollLockOnRoot(areModalsOpen);
    setOverlayIndicatorOnRoot(areModalsOpen);
  };
  return {
    pop: pop,
    push: push
  };
}

export { modalManager as default };
//# sourceMappingURL=modalManager.js.map
